const BlockActionDefault = {
    object_id : null,
    name : 'Untitled action',
    x : 0,
    y : 0,
    width : 5,
    height : 3,
    type : { name : 'action'},
    children : [
        {text: "", index : null, object_id : null, parent_block_id : null},
    ],
    action_type : null
}

const BlockActionServerDefault = {
    name : 'action'
}

export {BlockActionDefault, BlockActionServerDefault}